// extracted by mini-css-extract-plugin
module.exports = {"EventModal":"AbnormalModal_EventModal__3wm1C"};